import React from 'react';
import AssetsUploadContainer from '../../../Containers/UserContainer/AssetsUpload';

const AssetsUploadScreen = () => {
  return <AssetsUploadContainer />;
};

export default AssetsUploadScreen;
